import Dialog from '@mui/material/Dialog';
import Divider from '@mui/material/Divider';
import React from 'react';
import TermsOfUse from '~/components/TermsOfUse';
import NAMES from '~/constants/NAMES';
import getIcon from '~/helpers/getIcon';
import { StyledDialogContent, StyledDialogTitle, StyledIconButton } from './styles';
const IconClose = getIcon('actions.close');
export interface DialogTermsOfUseProps {
  onClose: () => void;
  open: boolean;
}
export const DialogTermsOfUse: React.FC<DialogTermsOfUseProps> = ({
  onClose,
  open
}: DialogTermsOfUseProps): React.ReactElement<DialogTermsOfUseProps> => <Dialog fullWidth maxWidth="md" onClose={onClose} open={open} data-sentry-element="Dialog" data-sentry-component="DialogTermsOfUse" data-sentry-source-file="index.tsx">
    <StyledDialogTitle data-sentry-element="StyledDialogTitle" data-sentry-source-file="index.tsx">{NAMES.APP} Terms of Use</StyledDialogTitle>

    <Divider data-sentry-element="Divider" data-sentry-source-file="index.tsx" />

    <StyledDialogContent data-sentry-element="StyledDialogContent" data-sentry-source-file="index.tsx">
      <StyledIconButton aria-label="Close Terms of Use Dialog" onClick={onClose} data-sentry-element="StyledIconButton" data-sentry-source-file="index.tsx">
        <IconClose data-sentry-element="IconClose" data-sentry-source-file="index.tsx" />
      </StyledIconButton>

      <TermsOfUse data-sentry-element="TermsOfUse" data-sentry-source-file="index.tsx" />
    </StyledDialogContent>
  </Dialog>;
export default DialogTermsOfUse;